export class BarcodeScannerViewModel {}
